__turbopack_context__.v({
  "dateCell": "tableRow-module-scss-module__w1H1pG__dateCell",
  "downloadLinksCell": "tableRow-module-scss-module__w1H1pG__downloadLinksCell",
  "row": "tableRow-module-scss-module__w1H1pG__row",
});
